import MovePredictions from './component';

export default MovePredictions;
